import React, { useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./ToastAlert.scss";

const ToastAlert = ({ error, msg }) => {
  useEffect(() => {
    const alert = document.querySelector("#toasterAlert");

    setTimeout(() => {
      alert.classList.remove("hide");
      alert.classList.add("show");
    }, 100);

    setTimeout(() => {
      alert.classList.remove("show");
    }, 4000);
  }, []);

  return (
    <div className="toaster">
      <div
        id="toasterAlert"
        className={`alert alert-${error ? "danger" : "success"}`}
        role="alert"
      >
        {msg}
      </div>
    </div>
  );
};

export default ToastAlert;
